<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" disabled/>
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full mt-4" label="Password" v-model="data_local.password" v-validate="'required|min:8'" name="password" />
          <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="save_changes"
            :disabled="!validateForm"
          >Save Changes</vs-button>
          <!--<vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '@/axios.js'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return;

      axios
        .post('/api/admin/add/partner', {
          'id' : this.$route.params.id,
          'name' : this.data_local.name,
          'password' : this.data_local.password
        })
        .then(res => {
          if(res.data.success) {
            this.$vs.notify({
              title: "Partner Updated",
              text: res.data.message,
              color: "success"
            })
          }else{
            this.$vs.notify({
              title: "Error",
              text: res.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            if (typeof error.response.data.errors !== "undefined") {
              for (var key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key))
                  this.$vs.notify({
                    title: "Error",
                    text: error.response.data.errors[key][0],
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger"
                  })
              }
            }
          }
        })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
